import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer-copyright">
        Copyright © tamilholybible.com · Kugathaj Kangeswaran. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;